import Article from "../../../../entities/article";

// NOTE: font-awesome-rails は v4.7 系のためFA4のクラス名を使う
export const CATEGORY_ICONS: { [key: string]: string } = {
  display_activity_locations_small: "fa-map-marker",
  prices: "fa-jpy",
  positions_and_age_group: "fa-user",
  dates_or_terms: "fa-calendar",
  frequents: "fa-calendar",
  terms_or_periods: "fa-calendar",
  member_activity_dates: "fa-calendar",
};

export type PortalBadge = { text: string; modifier: string };

export function buildAuthorTag(
  key: string | undefined,
  companyNameJa: string
): PortalBadge | null {
  const tags: { [key: string]: PortalBadge } = {
    company: { text: `${companyNameJa}からの募集`, modifier: "isCompany" },
    community_org: { text: "地域からの募集", modifier: "isCommunityOrg" },
    npo_etc: { text: "NPO等からの募集", modifier: "isNpoEtc" },
  };
  return (key && tags[key]) || null;
}

export function buildPortalBadges(article: Article): PortalBadge[] {
  const deadline = article.deadline_text();
  return [
    article.is_promotion() && { text: "注目", modifier: "isAccent" },
    article.is_closing() && { text: "募集終了", modifier: "isNeutral" },
    article.is_pausing() && { text: "受付停止中", modifier: "isNeutral" },
    ...article
      .working_form_labels_for_sp()
      .map((text) => ({ text, modifier: "isAccent" })),
    article.is_new_arrival() && { text: "新着", modifier: "isMainLight" },
    deadline && { text: deadline, modifier: "isMainLight" },
  ].filter((badge): badge is PortalBadge => Boolean(badge));
}
